export const LoadingFallback = () => {
  return (
    <div className="page-shell">
      <div className="flex h-64 items-center justify-center" role="status">
        <div className="loader" aria-hidden="true"></div>
        <span className="sr-only">Loading…</span>
      </div>
    </div>
  );
};
